/** Public marketing routes. One declaration per path; pages, nav and footer import from here. */
export const PUBLIC_PATH = Object.freeze({
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DEMO: '/demonstration',
  AVANCE: '/avance-immediate',
  CONTACT: '/contact',
  LEGAL_MENTIONS: '/legal-mentions',
  PRIVACY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service',
  TERMS_OF_SALE: '/terms-of-sale',
});

/** Section anchors of the home landing (`/#…`). */
export const LANDING_ANCHOR = Object.freeze({
  TOP: 'top',
  SIMULATOR: 'simulateur',
  TOOLS: 'outils',
  FEATURES: 'produit',
  FAMILY: 'famille',
  STUDENTS: 'eleves',
  PRICING: 'tarifs',
  FAQ: 'faq',
  TRIAL: 'essai',
});

export const FORMATIONS_URL = 'https://formations.neoprof.fr';
